/**
  * 专题 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const customerchat = {
    // 聊天用户列表
    userlist(params) {
        return axios.get(api + 'customerchat/userlist', { params: params });
    },
    // 聊天记录
    list(params) {
        return axios.get(api + 'customerchat/list', { params: params });
    },
    // 回复
    reply(params) {
        return axios.post(api + 'customerchat/reply', qs.stringify(params));
    },
};


// 导出接口
export default customerchat;